import { Observable, from } from 'rxjs';

import { Injectable } from '@angular/core';
import { OmniMaisRestService } from '../omni-rest/omni-mais/omni-mais-rest.service';
import { OmniWsRestService } from '../omni-rest/omni-ws/omni-ws-rest.service';
import { LoginCredencial } from './model/login-credencial';
import { LoginResult } from './model/login-result';
import { ChangePasswordRequest } from './model/change-password-request';
import { ChangePasswordResponse } from './model/change-password-response';
import { OmniMaisV2RestService } from '../omni-rest/omni-mais/omni-mais-v2-rest.service';
import { OmniGeralRestService } from '../omni-rest/omni-geral/omni-geral-rest.service';
import { map } from 'rxjs/operators';
import { CdcEstruturadoRestService } from '../omni-rest/cdc-estruturado/cdc-estruturado-rest.service';

@Injectable()
export class LoginService {
  constructor(
    private omniWsRestService: OmniWsRestService,
    private omniMaisRestService: OmniMaisRestService,
    private omniMaisV2RestService: OmniMaisV2RestService,
    public omniGeralRestService: OmniGeralRestService,
    private cdcEstruturadoRestService: CdcEstruturadoRestService
  ) {}

  login(credencial: LoginCredencial): Observable<LoginResult> {
    return this.omniWsRestService.post('user/login', {
      login: credencial.login,
      senha: credencial.senha,
    });
  }

  logout(): Observable<void> {
    return this.omniWsRestService.post('user/logout');
  }

  recoveryPassword(credencial: LoginCredencial): Observable<any> {
    return this.omniWsRestService.post('user/forgot-password', {
      login: credencial.login,
    });
  }

  changePassword(
    request: ChangePasswordRequest
  ): Observable<ChangePasswordResponse> {
    return this.omniWsRestService.put<ChangePasswordResponse>(
      'user/password',
      request
    );
  }

  getAndAuthenticateUser(usuarioTO: any): Observable<any> {
    if (usuarioTO.tokenPush) {
      return this.omniWsRestService.post('user/change-token-push', {
        tokenPush: usuarioTO.tokenPush,
      });
    }
    return from(
      new Promise((resolve, reject) => {
        resolve('SEM TOKEN PUSH');
      })
    );
  }

  selecionarAgente(idAgente: string) {
    return this.omniMaisRestService.post('usuario/selecionarAgentePorUsuario', {
      idAgente,
    });
  }

  public getSimulacaoTentativas(): Observable<any> {
    return this.omniGeralRestService.get('parametro/24/NR_BUSCA_RESULT_AA');
  }

  public getSimulacaoTempo(): Observable<any> {
    return this.omniGeralRestService.get(
      'parametro/24/INTERVALO_TEMPO_BUSCA_RESULT_AA'
    );
  }

  getItensPaginaHome(): Observable<{ key: string; value: string }> {
    return this.omniGeralRestService.get('parametro/24/NR_ITENS_PAGINA_HOME');
  }

  getAvailableCampaigns(): Observable<{ descricao: string; ativo: boolean }[]> {
    return this.omniMaisV2RestService.get('parameters/campaigns');
  }

  getUserSettings(): Observable<any> {
    return this.cdcEstruturadoRestService
      .get('/internal/setting/user-settings')
      .pipe(
        map((response: any) => {
          return response.partnerSettings;
        })
      );
  }
}
